<div class="main container-fluid">
  <app-building-management
  class="building-management"
    [buildingsList]="buildingsList"
  ></app-building-management>
</div>
